export default __webpack_public_path__ + "static/media/logo.c3e0d381.svg";